import React, { FC } from 'react';
import { View, ViewProps } from 'react-native';

import { Theme } from '@constants';

import { AirQualityCategoryIndex } from '../../../hooks/api/useGetAirQuality';

const airQualityColors = {
  [AirQualityCategoryIndex.Good]: '#8BD92F',
  [AirQualityCategoryIndex.Moderate]: '#F4DB37',
  [AirQualityCategoryIndex.UnhealthyToSensitiveGroups]: '#F05821',
  [AirQualityCategoryIndex.Unhealthy]: '#CA0016',
  [AirQualityCategoryIndex.Hazardous]: '#72001C',
  [AirQualityCategoryIndex.VeryUnhealthy]: '#D700A5',
};

export const TWCAirQualityIcon: FC<TWCAirQualityIconProps> = ({ categoryIndex, size = 24, testID, style }) => (
  <View
    style={[
      style,
      {
        width: Theme.px(size),
        height: Theme.px(size),
        borderRadius: Theme.px(size * 0.5),
        backgroundColor: airQualityColors[categoryIndex],
      },
    ]}
    testID={testID}
  />
);

type TWCAirQualityIconProps = {
  categoryIndex: CategodyIndes;
  size?: number;
} & ViewProps;

type CategodyIndes = typeof AirQualityCategoryIndex[keyof typeof AirQualityCategoryIndex];
